import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import InstallPrompt from '../Pwa/InstallPrompt';

/** O ecrã do sócio: o menu e o cabeçalho abrem UMA vez e as páginas trocam lá dentro (antes cada página abria o seu, ou não abria nenhum). */
export default function ClientLayout() {
  return (
    <DashboardLayout userType="client">
      <Outlet />
      <InstallPrompt />
    </DashboardLayout>
  );
}
